import { IRoute } from "store/api/types";

export const getAddressSteps = (arr: IRoute[]) => {
  if (arr.length >= 3) {
    return [arr[0], arr[arr.length - 1]].map((obj) => ({
      label: `${obj.name} ${obj.number || ""}`,
    }));
  } else {
    return arr.map((obj) => ({
      label: `${obj.name} ${obj.number || ""}`,
    }));
  }
};
